import { Outlet } from '@tanstack/react-router'
import { Sidebar } from './Sidebar'
import { Header } from './Header'
import { ErrorBoundary } from './ErrorBoundary'
import { useCurrentUser } from '@/hooks/useAuth'

export const AdminLayout = () => {
  // Revalidate token against /auth/me on mount (staleTime: 5min).
  // If user is suspended/deleted, the 401 interceptor in api.ts auto-logouts.
  useCurrentUser()

  return (
    <div className="min-h-screen bg-background">
      <div className="flex h-screen overflow-hidden">
        <Sidebar />
        <div className="flex flex-1 flex-col overflow-hidden">
          <Header />
          <main className="flex-1 overflow-y-auto p-6">
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </main>
        </div>
      </div>
    </div>
  )
}
